import { SystemOptionType, ValidSystemType } from 'data/types';
import { averagePresentScores } from 'utils/average-present-scores';

// Hours-weighted coverage of the required share, capped per temperature bin
// in the valid-systems SQL. The whole-room coverage stays what the cards
// display; this is what decides whether the system falls short of the share
// it was asked to carry.
export type ShareCoverageScores = {
  heatingShareScore: number | null;
  coolingShareScore: number | null;
};

type SystemWithShareScores = ValidSystemType & Partial<ShareCoverageScores>;
type OptionWithShareScores = SystemOptionType & Partial<ShareCoverageScores>;

export function shareCoverageScoresForSystems(
  systems: ValidSystemType[]
): ShareCoverageScores {
  const rows = systems as SystemWithShareScores[];
  return {
    heatingShareScore: averagePresentScores(
      rows.map((row) => row.heatingShareScore)
    ),
    coolingShareScore: averagePresentScores(
      rows.map((row) => row.coolingShareScore)
    )
  };
}

// Null when the option predates the share scores; callers fall back to the
// ratio-scaled whole-room threshold.
export function shareCoverageScoreOnOption(
  system: SystemOptionType,
  side: 'heating' | 'cooling'
): number | null {
  const value = (system as OptionWithShareScores)[
    side === 'heating' ? 'heatingShareScore' : 'coolingShareScore'
  ];
  return typeof value === 'number' && Number.isFinite(value) ? value : null;
}
